import { propAccessor } from '@hc-frontend/utils'
import { SURE_CARE_NAME } from 'core/constants/products'
import getCorrespondingPolicy from 'core/services/getPlansByProductId/getCorrespondingPolicy'
import getAndValidatePeriod from 'utils/pivot/plan/getAndValidateDuration'

const sortByMonthly = (
  predicate: (a: number, b: number) => number,
  plans: { [key: string]: Plan },
  period: number | string | number[] | undefined,
  a: number,
  b: number
) => {
  if (period instanceof Array) {
    return predicate(
      getCorrespondingPolicy({ plan: plans[a], additionalPeriods: period }).monthly
        .premium,
      getCorrespondingPolicy({ plan: plans[b], additionalPeriods: period }).monthly
        .premium
    )
  } else {
    const durations = getAndValidatePeriod(plans[a], period)
    if (!durations) {
      return predicate(
        plans[a]?.durationsArray[0]?.monthly.premium,
        plans[b]?.durationsArray[0]?.monthly.premium
      )
    } else {
      const firstKey = Object.keys(durations)[0]
      return predicate(
        propAccessor(getAndValidatePeriod(plans[a], period) || {}, [
          firstKey,
          'monthly',
          'premium'
        ]) || 0,
        propAccessor(getAndValidatePeriod(plans[b], period) || {}, [
          firstKey,
          'monthly',
          'premium'
        ]) || 0
      )
    }
  }
}

export default sortByMonthly
